/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  function updateCartCountBadges(count) {
    document.querySelectorAll('.cart__count').forEach((badge) => {
      if (count > 0) {
        badge.textContent = count;
        badge.style.display = '';
      } else {
        badge.style.display = 'none';
      }
    });
  }

  function fetchCartCount() {
    fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => updateCartCountBadges(cart.item_count))
      .catch(() => {});
  }

  ['theme:cart:added', 'theme:cart:refresh'].forEach((event) => {
    document.addEventListener(event, fetchCartCount);
  });







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
